/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
import GaugeChart from "react-gauge-chart";
import { useSelector } from "react-redux";
// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { BASE_URL } from "../utils/constants";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

var getSchGrades = (originArr = []) => {
  let grdsArr = [];
  originArr.forEach((section) => {
    section.period.forEach((period) => {
      period.assignment.forEach((ass) => {
        grdsArr.push(ass);
      });
    });
  });
  return grdsArr;
};

let courseDetails = [];

const Courses = () => {
  const [coursesStatistics, setCoursesStatistics] = useState([]);
  const [showAll, setShowAlll] = useState("");

  useEffect(async () => {
    try {
      await getCourses("");
    } catch {}
  }, []);

  
  const getCourses = async (All) => {
    Swal.showLoading();
    try {
     
      setCoursesStatistics([]);
      let res = await axios.post(
        `${BASE_URL}/student/getcoursesandperformance.php`,
        {
          all: All,
        }
      );
     
      res.data.data.courses.forEach((course) => {
        courseDetails.push({
          id: course.id,
          name: course.coursename,
          // exams: gradess,
          performance: Number(course?.performance / 100),
        });
      });

      

      setCoursesStatistics(courseDetails);

      courseDetails = [];
    } catch (e) {
      Swal.fire("Error while getting courses", "", "error");
    } finally {
      Swal.close();
    }
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card>
              <CardHeader>
                <h4 className="title">Courses</h4>
              </CardHeader>
              <CardBody className="all-icons">
                <div>
                  <div className="form-check form-check-inline ">
                    <input
                      style={{ marginRight: "-20%" }}
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      defaultChecked={true}
                      onChange={(e) => {
                        setShowAlll("");
                        getCourses("");
                      }}
                      value="option1"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">
                      Current Courses
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      style={{ marginRight: "-20%" }}
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      onChange={(e) => {
                        setShowAlll("all");
                        getCourses("all");
                      }}
                      id="inlineRadio2"
                      value="option2"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">
                      Archived Courses
                    </label>
                  </div>
                </div>
                <Row>
                  {coursesStatistics?.map((course, key) => {
                  
                    return (
                      <Col
                        lg={4}
                        sm={6}
                        xs={12}
                        className="font-icon-list"
                        key={key}
                        style={{ textAlign: "center" }}
                      >
                        <Link to={`/course/${course.id}`}>
                          <div className="font-icon-detail bg-dark py-2 px-0">
                            <h5 style={{ fontWeight: "bold" }}>
                              {course?.name}
                            </h5>
                            <h5>Overall Performance</h5>
                            <GaugeChart
                              id="gauge-chart2"
                              nrOfLevels={20}
                              percent={
                                course?.performance == -0.01
                                  ? NaN
                                  : course?.performance
                              }
                              needleColor="#3452f5"
                              style={{
                                height: "60%",
                                width: "80%",
                                margin: "0 auto",
                              }}
                            />
                          </div>
                        </Link>
                      </Col>
                    );
                  })}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Courses;
